import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";

import ModalConfirmButton from '../components/modal_close_button.tsx';
import { ModalClose } from '../components/modal-close.tsx';

export default function ModalInfoGEG() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1 id="modal-title">Was bedeutet GEG / BEG?</h1>
            <p id="modal-description">
            Je kleiner der WLG ist, desto besser die Wärmedämmung. Für BEG-Bundesförderung müssen bessere Dämmwerte erreicht werden.
            </p>
           <ModalClose label={"weiter"} onClick={()=>{
                           pop_modal();
                       }}/>
         </Panel>)
}

